'use es6';

export default function invariant(condition, message) {
  var booleanCondition = Boolean(condition);
  if (!booleanCondition) {
    throw new Error(message || 'Unexpected invariant triggered');
  }
}